import {useAsyncResult} from "../../hooks/useAsyncResult"
import Skeleton from "react-loading-skeleton"
import {useAccessToken} from "../../services/auth"
import React, {ComponentClass, FunctionComponent} from "react"
import {getUser, User} from "../../resources/user"
import {ErrorDocument, OkDocument, Resource} from "../../resources/common"

type ElementProps<P> = Pick<Props<P> & P, Exclude<keyof P, "element" | "userId" | "onResult" | "onFailed" | "included">>

interface Props<P> {
	userId: string
	element?: FunctionComponent<ElementProps<P>> | ComponentClass<ElementProps<P>> | string
	onResult: (user: User) => JSX.Element
	onFailed?: (err: any) => JSX.Element
	included?: Resource[]
}

function UserNameInternal<P>({userId, element = "td", onResult, onFailed, included, ...props}: Props<P> & P) {
	if (included) {
		const user = included.find((r) => r.type === "unitUser" && r.id === userId)
		if (user && user.type === "unitUser") {
			return onResult(user)
		}
	}

	const accessToken = useAccessToken()
	const result = useAsyncResult<OkDocument<User>, ErrorDocument>(() => getUser(accessToken, userId), [userId])

	return result.match(
		() => React.createElement<ElementProps<P>>(element, props, <Skeleton />),
		(user) => onResult(user.data),
		(err) => (onFailed ? onFailed(err) : React.createElement<ElementProps<P>>(element, props, "Error"))
	)
}

export function UserName<P extends {}>(props: Props<P> & P) {
	return <UserNameInternal {...props} />
}
